
export default function Testimonials() {
  const testimonials = [
    {
      name: "A.K様",
      age: "40代女性",
      experience: "1ヶ月",
      comment: "長年の薄毛に悩んでいましたが、こちらでケアを受けるようになってから、髪にコシが出てきたように感じます。専門的なカウンセリングで自分の頭皮の状態がよく分かり、適切なケア方法を教えていただけました。まだ1ヶ月ですが、変化を実感できて嬉しいです。",
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/cc57ae63d9d5b1ccdc2f9fcedfda28dd.jpg"
    },
    {
      name: "M.T様", 
      age: "50代男性",
      experience: "3ヶ月",
      comment: "抜け毛が気になり始めて相談しました。3ヶ月間通わせていただき、明らかに抜け毛が減りました。頭皮の状態も改善され、髪にツヤが戻ってきたように思います。スタッフの方々の専門知識が深く、安心してお任せできます。継続して通いたいと思います。",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Black%20and%20white%20silhouette%20of%20person%20face%20and%20decollete%20from%20front%20view%2C%20professional%20head%20silhouette%20facing%20forward%2C%20mature%20person%20in%20their%2050s%20front-facing%20portrait%20silhouette%2C%20clean%20minimalist%20facial%20silhouette%20design%2C%20monochrome%20black%20silhouette%20on%20white%20background%2C%20geometric%20head%20and%20shoulders%20silhouette&width=300&height=300&seq=front-silhouette-person-50s&orientation=squarish"
    },
    {
      name: "R.H様",
      age: "60代女性", 
      experience: "6ヶ月",
      comment: "年齢とともに髪のボリュームが気になっていましたが、6ヶ月間のケアで髪にハリとコシが戻ってきました。何より頭皮の健康状態が改善されたことを実感しています。丁寧なカウンセリングと専門的な技術で、髪の悩みが解消されて本当に感謝しています。",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Black%20and%20white%20silhouette%20of%20person%20face%20and%20decollete%20from%20front%20view%2C%20professional%20head%20silhouette%20facing%20forward%2C%20mature%20person%20in%20their%2040s%20front-facing%20portrait%20silhouette%2C%20clean%20minimalist%20facial%20silhouette%20design%2C%20monochrome%20black%20silhouette%20on%20white%20background%2C%20geometric%20head%20and%20shoulders%20silhouette&width=300&height=300&seq=front-silhouette-person-40s-rh&orientation=squarish"
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            お客様の声
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            実際にケアを受けられたお客様から寄せられた
            貴重なお声をご紹介いたします。
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-lg p-6 sm:p-8 shadow-lg">
              <div className="flex items-center mb-4 sm:mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 sm:w-16 sm:h-16 rounded-full mr-3 sm:mr-4 object-cover object-top flex-shrink-0"
                />
                <div className="min-w-0">
                  <h4 className="text-base sm:text-lg font-bold text-gray-900 truncate">{testimonial.name}</h4>
                  <p className="text-gray-600 text-xs sm:text-sm">{testimonial.age}</p>
                  <p className="text-gray-500 text-xs">ケア期間：{testimonial.experience}</p>
                </div>
              </div>
              
              <div className="flex mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-base sm:text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed text-xs sm:text-sm italic">
                "{testimonial.comment}"
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-12">
          <p className="text-gray-600 text-xs sm:text-sm">
            ※個人の感想であり、効果には個人差があります。
          </p>
        </div>
      </div>
    </section>
  );
}
